import * as d3 from "d3";
import {colonAnnotation, inrFormatter, numberFormat, responsivefy} from '../functions'

export default function (chart, divId, vizName,resData, filterParam) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName,filterParam);

    var renameKeys = function (obj) {
        /*Recursively renames "key" keys to "name" and
                renames "values" keys to "children" */
        obj.name = obj.key
        delete obj.key
        if (obj.values) {
            obj.children = obj.values
            delete obj.values
            obj.children.forEach(renameKeys)
        }
        return obj
    }

    // axios.post(url, filterParam).then(response => {
        let res = resData

        var data = d3.nest()
            .key(function (d) {
                return d.dim1_name
            })
            .rollup(function (v) {
                return {
                    curr_from_date: v[0].dim4_name,
                    curr_to_date: v[0].dim5_name,
                    prev_from_date: v[0].dim2_name,
                    prev_to_date: v[0].dim3_name,
                    rate: d3.sum(v, function (d) {
                        return d.metric1;
                    }),
                    sum: d3.sum(v, function (d) {
                        return d.metric2;
                    })
                }
            })
            .entries(res);

        var expenseMetrics = d3.nest()
            .entries(data)
            .map(function (group) {
                return {
                    key: group.key,
                    curr_from_date: group.value.curr_from_date,
                    curr_to_date: group.value.curr_to_date,
                    prev_from_date: group.value.prev_from_date,
                    prev_to_date: group.value.prev_to_date,
                    rate: group.value.rate,
                    sum: group.value.sum,
                }
            });
        /*The visualization requires there to be a root node*/
        var Data = {key: chart.y1AxisDisplayName, values: []}
        Data.values = expenseMetrics
        renameKeys(Data);

        (function visualize() {
            var transitioning

            var x1Scale = d3.scaleLinear().domain([0, chart.width]).range([0, chart.width])
            var y1Scale = d3.scaleLinear()
                .domain([0, chart.height - chart.margin.top - chart.margin.bottom])
                .range([0, chart.height - chart.margin.top - chart.margin.bottom])

            var metric1ColorScale = d3.scaleLinear()
                .domain([d3.min(expenseMetrics, function (d) {
                    return d.rate
                }), 0])
                .range(["#a50f15", "#fb6a4a"])
            var metric2ColorScale = d3.scaleLinear()
                .domain([0, d3.max(expenseMetrics, function (d) {
                    return d.rate
                })])
                .range(["#74c476", "#006d2c"])

            var svg, grandparent

            updateDrillDown()

            function updateDrillDown() {
                if (svg) {
                    svg.selectAll('*').remove()
                } else {
                    svg = d3.select(divId).select("svg").remove();
                    svg = d3.select(divId).append('svg')
                        .attr('width', chart.width - chart.margin.left - chart.margin.right)
                        .attr('height', chart.height - chart.margin.bottom - chart.margin.top)
                        .style('margin-left', -chart.margin.left + 'px')
                        .style('margin.right', -chart.margin.right + 'px')
                        .call(responsivefy)
                        .append('g')
                        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')
                        .style('shape-rendering', 'crispEdges')

                    grandparent = svg.append('g').attr('fill', 'orange')

                    grandparent.append('rect')
                        .attr('y', -chart.margin.top)
                        .attr('width', chart.width)
                        .attr('height', chart.margin.top)
                    //  .attr('stroke-width', '6px')

                    grandparent.append('text')
                        .attr('x', 6)
                        .attr('y', 6 - chart.margin.top)
                        .attr('dy', '.75em')

                    var treemap = d3.treemap()
                        .tile(d3.treemapResquarify.ratio(chart.height / chart.width * 0.5 * (1 + Math.sqrt(5))))
                        .size([chart.width, chart.height])
                        .round(false)
                        .paddingInner(1)
                }

                var root = d3.hierarchy(Data)
                    .eachBefore(function (d) {
                        d.id = (d.parent ? d.parent.id + '.' : '') + d.data.name
                    })
                    .sum((d) => d.sum)
                    .sort(function (a, b) {
                        return b.height - a.height || b.value - a.value
                    })

                initialize(root)
                accumulate(root)
                layout(root)
                treemap(root)
                display(root)
            }

            function initialize(root) {
                root.x = root.y = 0
                root.x1 = chart.width
                root.y1 = chart.height
                root.depth = 0
            }

            // Aggregate the values for internal nodes. This is normally done by the
            // treemap layout, but not here because of our custom implementation.
            // We also take a snapshot of the original children (_children) to avoid
            // the children being overwritten when when layout is computed.
            function accumulate(d) {
                d._children = d.children
                return (d._children) ? d.value = d.children.reduce(function (p, v) {
                    return p + accumulate(v)
                }, 0) : d.value
            }

            // Compute the treemap layout recursively such that each group of siblings
            // uses the same size (1×1) rather than the dimensions of the parent cell.
            // This optimizes the layout for the current zoom state. Note that a wrapper
            // object is created for the parent node for each group of siblings so that
            // the parent’s dimensions are not discarded as we recurse. Since each group
            // of sibling was laid out in 1×1, we must rescale to fit using absolute
            // coordinates. This lets us use a viewport to zoom.
            function layout(d) {
                if (d._children) {
                    d._children.forEach(function (c) {
                        c.x0 = d.x0 + c.x0 * d.x1
                        c.y0 = d.y0 + c.y0 * d.y1
                        c.x1 *= (d.x1 - d.x0)
                        c.y1 *= (d.y1 - d.y0)
                        c.parent = d
                        layout(c)
                    })
                }
            }

            function display(d) {
                grandparent
                    .datum(d.parent)
                    .on('click', transition)
                    .select('text')
                    .text(name(d))
                    .attr('fill', 'black')

                var g1 = svg.insert('g', '.grandparent').datum(d).attr('class', 'depth')
                var g = g1.selectAll('g').data(d._children).enter().append('g')

                g.filter(function (d) {
                    return d._children
                })
                    .classed('children', true)
                    .on('click', transition)

                var children = g.selectAll('.child')
                    .data(function (d) {
                        return d._children || [d]
                    })
                    .enter().append('g')

                children.append('rect').attr('fill', 'white').call(rect)

                /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
                         var y1tip = tooltip_class()

                         y1tip.attr('class', 'd3-tip'+divId.id)
                            .html((d) =>{
                                return chart.x1MetricTooltip+ colonAnnotation + d.data.name + "<br/>" +
                                       chart.y1MetricTooltip+ colonAnnotation + numberFormat(d.value) +
                                       "(" + inrFormatter(d.data.rate) + "%" + ")" + "<br/>" +
                                        chart.x2MetricTooltip +colonAnnotation + d.data.curr_from_date+ " " +
                                         "to"  + " "+ d.data.curr_to_date +
                                         "<br/>" + chart.y2MetricTooltip+colonAnnotation + d.data.prev_from_date + "to" + " " + d.data.prev_to_date
                             })

                         g.call(y1tip)*/

                d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
                var div = d3.select(divId).append('div').attr('class', 'tooltip')
                    .attr('style', 'position: absolute; opacity: 0;')

                children.append('text')
                    .attr('class', 'ctext')
                    .text(function (d) {
                        return d.data.name.length > 5 ? (d.data.name.substring(0, 5) + "..") : d.data.name
                    })
                    .call(text2)

                g.append('rect').attr('class', 'parent').call(rect)

                var t = g.append('text').attr('class', 'ptext').attr('dy', '.75em')

                t.append('tspan')
                    .attr("font-size", "11px")
                    .text(function (d) {
                        return d.data.name.length > 5 ? (d.data.name.substring(0, 5) + "..") : d.data.name
                    })

                t.append('tspan').attr('dy', '1.0em')
                    .attr("font-size", "11px")
                    .text(function (d) {
                        return numberFormat(d.value)
                    })
                t.append('tspan').attr('dy', '1.0em')
                    .attr("font-size", "11px")
                    .text(function (d) {
                        return Math.round(d.data.rate) + "%"
                    })

                t.call(text)

                g.selectAll('rect')
                    .style("fill", function (d) {
                        return d.data.rate < 0 ? metric1ColorScale(d.data.rate) : metric2ColorScale(d.data.rate);
                    })
                    .on("mousemove", function (d) {
                        console.log(d3.event, d)
                        div.transition()
                            .duration(200)
                            .style("opacity", .9);
                        div.html(chart.x1MetricTooltip + colonAnnotation + d.data.name + "<br/>" +
                            chart.y1MetricTooltip + colonAnnotation + numberFormat(d.value) +
                            "(" + inrFormatter(d.data.rate) + "%" + ")" + "<br/>" +
                            chart.x2MetricTooltip + colonAnnotation + d.data.curr_from_date + " " +
                            "to" + " " + d.data.curr_to_date +
                            "<br/>" + chart.y2MetricTooltip + colonAnnotation + d.data.prev_from_date + "to" + " " + d.data.prev_to_date
                        )
                            .style("left", (d3.event.layerX) + "px")
                            .style("top", (d3.event.layerY) + "px");
                    })
                    .on("mouseout", function () {
                        div.transition().style("opacity", 0)
                    });
                //.on("mouseover", y1tip.show)
                //.on("mouseout", y1tip.hide)
                //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

                function transition(d) {
                    if (transitioning || !d) return
                    transitioning = true
                    var g2 = display(d),
                        t1 = g1.transition().duration(750),
                        t2 = g2.transition().duration(750)

                    // Update the domain only after entering new elements.
                    x1Scale.domain([d.x0, d.x0 + (d.x1 - d.x0)])
                    y1Scale.domain([d.y0, d.y0 + (d.y1 - d.y0)])

                    // Enable anti-aliasing during the transition.
                    svg.style('shape-rendering', null)

                    // Draw child nodes on top of parent nodes.
                    svg.selectAll('.depth').sort(function (a, b) {
                        return a.depth - b.depth
                    })

                    // Fade-in entering text.
                    g2.selectAll('text').style('fill-opacity', 0)

                    // Transition to the new view.
                    t1.selectAll('.ptext').call(text).style('fill-opacity', 0)
                    t2.selectAll('.ptext').call(text).style('fill-opacity', 1)
                    t1.selectAll('.ctext').call(text2).style('fill-opacity', 0)
                    t2.selectAll('.ctext').call(text2).style('fill-opacity', 1)
                    t1.selectAll('rect').call(rect)
                    t2.selectAll('rect').call(rect)

                    // Remove the old node when the transition is finished.
                    t1.remove().on('end', function () {
                        svg.style('shape-rendering', 'crispEdges')
                        transitioning = false
                    })
                }

                return g
            }

            function text(text) {
                text.selectAll('tspan')
                    .attr('x', function (d) {
                        return x1Scale(d.x0) + 6
                    })
                text.attr('x', function (d) {
                    return x1Scale(d.x0) + 6
                })
                    .attr('y', function (d) {
                        return y1Scale(d.y0) + 3
                    })
                    .style('opacity', function (d) {
                        var w = x1Scale(d.x1) - x1Scale(d.x0)
                        return this.getComputedTextLength() < w - 6 ? 1 : 0
                    })
            }

            function text2(text) {
                text.attr('x', function (d) {
                    return x1Scale(d.x1) - this.getComputedTextLength() - 6
                })
                    .attr('y', function (d) {
                        return y1Scale(d.y1) - 6
                    })
                    .style('opacity', function (d) {
                        var w = x1Scale(d.x1) - x1Scale(d.x0)
                        return this.getComputedTextLength() < w - 6 ? 1 : 0
                    })
            }

            function rect(rect) {
                rect.attr('x', function (d) {
                    return x1Scale(d.x0)
                })
                    .attr('y', function (d) {
                        return y1Scale(d.y0)
                    })
                    .attr('width', function (d) {
                        var w = x1Scale(d.x1) - x1Scale(d.x0)
                        return w
                    })
                    .attr('height', function (d) {
                        var h = y1Scale(d.y1) - y1Scale(d.y0)
                        return h
                    })
            }

            function name(d) {
                return d.parent ? name(d.parent) + ' / ' + d.data.name + ' (' + numberFormat(d.value) + ')' : d.data.name + ' (' + numberFormat(d.value) + ')'
            }
        })(Data)
    // })
}
